module.exports = __webpack_public_path__ + "img/flexibilidade_horarios.537ba21d.svg";